"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosHttpClient = void 0;
const axios_1 = __importDefault(require("axios"));
const hub_utilities_replenishment_1 = require("@yw/hub.utilities.replenishment");
const EndpointClient_1 = require("../../application/services/EndpointClient");
const _1 = require(".");
const AxiosRefreshTokenInterceptor_1 = require("./interceptors/AxiosRefreshTokenInterceptor");
const AxiosResponseInterceptor_1 = require("./interceptors/AxiosResponseInterceptor");
const AuthInterceptor_1 = require("./interceptors/AuthInterceptor");
class AxiosHttpClient extends EndpointClient_1.EndpointClient {
    constructor(instanceConfig = {}) {
        super();
        this.configurations = instanceConfig;
        this.axiosInstance = axios_1.default.create(instanceConfig);
        this.requestInterceptors = this.axiosInstance.interceptors.request;
        this.responseInterceptors = this.axiosInstance.interceptors.response;
        const authInterceptor = new AuthInterceptor_1.AuthInterceptor(this.axiosInstance);
        const axiosRefreshTokenInterceptor = new AxiosRefreshTokenInterceptor_1.AxiosRefreshTokenInterceptor(this.axiosInstance, {
            refreshTokenKey: instanceConfig.refreshTokenKey,
            refreshTokenUrl: instanceConfig.refreshTokenUrl,
            errorCallback: instanceConfig.errorCallback,
        });
        const axiosResponseInterceptor = new AxiosResponseInterceptor_1.AxiosResponseInterceptor(this.axiosInstance);
        authInterceptor.setupInterceptor();
        axiosRefreshTokenInterceptor.setupInterceptor();
        axiosResponseInterceptor.setupInterceptor();
    }
    setConfigurations(configurations) {
        this.configurations = (0, hub_utilities_replenishment_1.merge)(this.configurations, configurations);
    }
    getConfigurations() {
        return this.configurations;
    }
    registerRequestInterceptor(onFulfilled, onRejected) {
        return this.axiosInstance.interceptors.request.use(onFulfilled, onRejected);
    }
    ejectRequestInterceptor(id) {
        this.requestInterceptors.eject(id);
    }
    registerResponseInterceptor(onFulfilled, onRejected) {
        return this.axiosInstance.interceptors.response.use(onFulfilled, onRejected);
    }
    ejectResponseInterceptor(id) {
        this.responseInterceptors.eject(id);
    }
    request(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const adaptConfig = _1.AxiosRequestAdapter.adaptAxiosRequest(Object.assign(Object.assign({ duplicate: true }, this.configurations), config));
            const response = yield this.axiosInstance.request(adaptConfig);
            const adaptResponse = _1.AxiosResponseAdapter.adaptAxiosResponse(response);
            return (_a = adaptResponse === null || adaptResponse === void 0 ? void 0 : adaptResponse.data) === null || _a === void 0 ? void 0 : _a.data;
        });
    }
}
exports.AxiosHttpClient = AxiosHttpClient;
//# sourceMappingURL=AxiosHttpClient.js.map